import type { IGIKCompetitor } from '@gik/marketing/models/IGIKCompetitor';

export const giveinkind: IGIKCompetitor = {
  id: 'giveinkind',
  name: 'GiveInKind',
  features: {
    pageCreation: true,
    mealCalendar: true,
    nonMealRequestCalendar: true,
    donationsFundraising: true,
    postUpdates: true,
    messageUsers: true,
    productWishlist: true,
    productRecommendation: true,
    whatToSayRecommendations: true,
    notificationPreferences: true,
    comments: true,
  },
};

export const mealtrain: IGIKCompetitor = {
  id: 'mealtrain',
  name: 'MealTrain',
  features: {
    pageCreation: true,
    mealCalendar: true,
    nonMealRequestCalendar: true,
    donationsFundraising: true,
    postUpdates: true,
    messageUsers: true,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const gofundme: IGIKCompetitor = {
  id: 'gofundme',
  name: 'GoFundMe',
  features: {
    pageCreation: false,
    mealCalendar: false,
    nonMealRequestCalendar: false,
    donationsFundraising: true,
    postUpdates: false,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const caringbridge: IGIKCompetitor = {
  id: 'caringbridge',
  name: 'CaringBridge',
  features: {
    pageCreation: true,
    mealCalendar: true,
    nonMealRequestCalendar: true,
    donationsFundraising: false,
    postUpdates: true,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: true,
    comments: true,
  },
};

export const savo: IGIKCompetitor = {
  id: 'savo',
  name: 'Savo',
  features: {
    pageCreation: true,
    mealCalendar: true,
    nonMealRequestCalendar: true,
    donationsFundraising: false,
    postUpdates: false,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const takethemameal: IGIKCompetitor = {
  id: 'takethemameal',
  name: 'Take Them A Meal',
  features: {
    pageCreation: false,
    mealCalendar: false,
    nonMealRequestCalendar: false,
    donationsFundraising: false,
    postUpdates: false,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const supportful: IGIKCompetitor = {
  id: 'supportful',
  name: 'Supportful',
  features: {
    pageCreation: false,
    mealCalendar: true,
    nonMealRequestCalendar: false,
    donationsFundraising: true,
    postUpdates: true,
    messageUsers: false,
    productWishlist: true,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const whatfriendsdo: IGIKCompetitor = {
  id: 'whatfriendsdo',
  name: 'WhatFriendsDo.com',
  features: {
    pageCreation: false,
    mealCalendar: false,
    nonMealRequestCalendar: false,
    donationsFundraising: false,
    postUpdates: false,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const lotsahelpinghands: IGIKCompetitor = {
  id: 'lotsahelpinghands',
  name: 'Lotsa Helping Hands',
  features: {
    pageCreation: true,
    mealCalendar: true,
    nonMealRequestCalendar: true,
    donationsFundraising: false,
    postUpdates: true,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const carecalendar: IGIKCompetitor = {
  id: 'carecalendar',
  name: 'CareCalendar.org',
  features: {
    pageCreation: false,
    mealCalendar: false,
    nonMealRequestCalendar: false,
    donationsFundraising: false,
    postUpdates: false,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const familyproud: IGIKCompetitor = {
  id: 'familyproud',
  name: 'Family Proud',
  features: {
    pageCreation: false,
    mealCalendar: false,
    nonMealRequestCalendar: false,
    donationsFundraising: false,
    postUpdates: false,
    messageUsers: false,
    productWishlist: false,
    productRecommendation: false,
    whatToSayRecommendations: false,
    notificationPreferences: false,
    comments: false,
  },
};

export const competitors: IGIKCompetitor[] = [giveinkind, mealtrain, gofundme, caringbridge, savo, lotsahelpinghands];
